import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var salesReportingURL = {
    MTFReport: URLConfig.config.apiBase +
        microService.dashboardService +
        "Report/MTFPledge",
    HolidayListApi: URLConfig.config.apiBase +
        microService.dashboardService +
        "Report/holidaylist",
    AllReport: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "KPIReport/reportList",
    getParticularReportParamsData: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "KPIReport/reportData",
    getPaginatedListOfReports: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "KPIReport/reports",
    reportMainData: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "KPIReport/report",
    dropdownList: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "Config/ddl",
    clientReport: URLConfig.config.apiBase +
        microService.dashboardService +
        "Report/clientreport",
    zeroisingLabel: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "Config/zerolabel",
    Ibeats: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "ZerosingPopupReport/Ibeats",
    ZeroisingPopupView: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "ZerosingPopupReport/View",
    ZeroisingPopupPublish: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "ZerosingPopupReport/publish",
    tableHeader: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "TableEvents/tableHeader",
    tableclick: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "TableEvents/tableclick",
};
export default salesReportingURL;
